<template>
  <div class="wrap">

    <div class="date-time-wrap"
         :class="{'admin-date-time-wrap' : isAdminSpaceDetail}">
      <div class="relative date-picker-wrap point"
           :class="{'admin-date-picker-wrap' : isAdminSpaceDetail}">
        <img src="../../assets/image/icon/space/calendar_month.svg"
             alt="">
        <div id="datepicker">{{ startDateShow }}</div>
        <div class="absolute left-0 top-0 right-0 bottom-0" @click="handleDateClick"></div>
      </div>

      <div class="time-picker-wrap"
           :class="{'admin-time-picker-wrap' : isAdminSpaceDetail}">
        <div class="time-picker point">
          <img src="../../assets/image/icon/space/pace.svg"
               alt=""/>
          <select class="point"
                  v-model="startTime"
                  @change="startTimeSelected">
            <option disabled
                    value="">{{ $t('space.start_time') }}
            </option>
            <option v-for="time in startTimeArr"
                    :value="time">
              {{ time }}
            </option>
          </select>
        </div>
        <img src="../../assets/image/icon/space/arrow_left.svg"
             alt="">
        <div class="time-picker point">
          <img src="../../assets/image/icon/space/pace.svg"
               alt=""/>
          <select class="point"
                  v-model="endTime"
                  @change="endTimeSelected">
            <option disabled
                    value="">{{ $t('space.end_time') }}
            </option>
            <option v-for="time in endTimeArr"
                    :value="time">
              {{ time }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="time-block-wrap"
         :class="{'admin-time-block-wrap' : isAdminSpaceDetail}">
      <div v-for="time in timeBlockArr"
           class="time-block">
        <div class="block"
             :class="{'time-block-disable' : time.isDisable, 'time-block-active' : time.isActive}"/>
        <div class="time-block time-block-text">
          {{ time.label }}
        </div>
      </div>
    </div>

  </div>
</template>
<script setup>
import {computed, onMounted, ref} from "vue";
import {DateTime, easepick, LockPlugin} from '@easepick/bundle';
import {DateFormat} from "@/utils/dateFormat.js";
import {getSpaceUsageStatus} from "@/api/space";
import {addOneDay, adjustTimeToNearest30, convertTo24HourFormat} from "@/utils/parseTool.js";
import {isDateLocked} from "~/utils/newPriceTool.ts";
import {canRentMaxDay} from "@/config/common.js";

const picker = ref(null)
const startDate = ref('')
const startDateShow = ref('')

const rentSetting = ref(null)

const startTimeArr = ref([])
const startTime = ref('')
const endTimeArr = ref([])
const endTime = ref('')

const timeBlockArr = ref([])

const props = defineProps({
  spaceId: {
    type: Number,
    default: -1
  },
  advanceBookingDays: {
    type: Number,
    default: 0
  },
  spaceUsageStatus: {
    type: Array,
    default: []
  },
  isAdminSpaceDetail: {
    type: Boolean,
    default: false
  },
  spaceRent: {
    type: Object,
    default: undefined
  },
})
const lockDate = computed(() => {
  return props.spaceUsageStatus
      .filter(d => d.begin_time === '00:00:00' && d.end_time === '23:59:59')
      .map(d => new DateTime(d.date, 'YYYY/MM/DD'))
})

const emit = defineEmits(['onTimeSelected'])

function onTimeSelected() {
  const isOK = startDate.value !== '' && startTime.value !== '' && endTime.value !== ''
  const rent_type = 0
  let begin_time = `${startDate.value} ${startTime.value}:00`
  let end_time = `${startDate.value} ${endTime.value}:00`
  /// 跨日
  if (parseInt(startTime.value?.slice(0, 2)) >= 24) {
    begin_time = `${addOneDay(startDate.value)} ${convertTo24HourFormat(startTime.value)}:00`
  }
  if (parseInt(endTime.value?.slice(0, 2)) >= 24) {
    end_time = `${addOneDay(startDate.value)} ${convertTo24HourFormat(endTime.value)}:00`
  }

  /// 時間條 ui
  timeBlockArr.value.forEach(t => t.isActive = false)
  if (isOK) {
    let timeFlag = startTime.value
    const activeTime = () => {
      timeBlockArr.value.filter(t => t.time === timeFlag).forEach(t => t.isActive = true)
    }
    activeTime()
    while (timeFlag !== endTime.value) {
      if (timeFlag.endsWith('00')) {
        timeFlag = timeFlag.slice(0, 2) + ':30'
      } else {
        timeFlag = (parseInt(timeFlag.slice(0, 2)) + 1).toString().padStart(2, '0') + ':00'
      }
      activeTime()
    }
  }

  emit('onTimeSelected', isOK, rent_type, begin_time, end_time)
}

watch(() => props.spaceRent, () => {
  updatePicker()
})

function updatePicker() {
  picker.value?.destroy()
  initDatePicker()
}

onMounted(() => {
  initDatePicker()
})

function initDatePicker() {
  const todayDate = new Date();
  const maxDate = new Date().setDate(todayDate.getDate() + canRentMaxDay);

  startTime.value = '';
  endTime.value = '';

  todayDate.setDate(todayDate.getDate() + props.advanceBookingDays)

  const defaultDay = new Date()
  defaultDay.setDate(defaultDay.getDate() + props.advanceBookingDays)

  /////////////////////////////////////////////////////////////////////
  /// 避開已預定日期邏輯 start
  /////////////////////////////////////////////////////////////////////
  /// 原先避開已預定日期邏輯
  // for (let i = 0; i < props.spaceUsageStatus.length; i++) {
  //   if (props.spaceUsageStatus[i].date === DateFormat.format.date(defaultDay, 'yyyy/MM/dd')) {
  //     defaultDay.setDate(defaultDay.getDate() + 1)
  //   }
  // }

  /// 新 避開已預定日期邏輯
  const isLocked = (date) => {
    const formattedDate = DateFormat.format.date(date, 'yyyy/MM/dd');
    return (
        date.inArray(lockDate.value, '[]') ||
        isDateLocked(props.spaceRent, formattedDate) ||
        props.spaceUsageStatus.some((status) => status.date === formattedDate)
    )
  }
  let count = 0
  while (isLocked(new DateTime(defaultDay, 'YYYY/MM/DD')) && count < canRentMaxDay) {
    defaultDay.setDate(defaultDay.getDate() + 1)
    count++
  }
  /////////////////////////////////////////////////////////////////////
  /// 避開已預定日期邏輯 end
  /////////////////////////////////////////////////////////////////////

  let option = {
    element: document.getElementById('datepicker'),
    plugins: [LockPlugin],
    css: [
      'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css'
    ],
    zIndex: 99,
    lang: 'zh-TW',
    date: defaultDay,
    format: 'YYYY年MM月DD日',
    LockPlugin: {
      minDate: todayDate,
      maxDate: maxDate,
      inseparable: true,
      filter(date, picked) {
        return date.inArray(lockDate.value, '[]') || isDateLocked(props.spaceRent, DateFormat.format.date(date, 'yyyy/MM/dd'))
      }
    },
    setup(picker) {
      picker.on('select', selectDate)
    },
  }

  picker.value = new easepick.create(option);

  // 確保有全部可以選的日期都被禁止不給選，所以不管能不能選，都一樣call重置時間條跟金額試算
  handleSpaceInfo(defaultDay, true, 1)

  /// 確保選中的日期是可下單，才繼續處理選項
  /*if (!isLocked(new DateTime(defaultDay, 'YYYY/MM/DD'))) {
    handleSpaceInfo(defaultDay, true, 1)
  }*/
}

function handleDateClick() {
  document.getElementById('datepicker').click();
}

function selectDate(event) {
  startDate.value = DateFormat.format.date(event.detail.date, 'yyyy/MM/dd')
  startDateShow.value = DateFormat.format.date(event.detail.date, 'yyyy年MM月dd日 (E)')
  handleSpaceInfo(event.detail.date)
}

async function handleSpaceInfo(date, isMounted = false, count = 1) {
  /// 清空時間選取
  startTimeArr.value = []
  startTime.value = ''
  endTimeArr.value = []
  endTime.value = ''
  timeBlockArr.value = [] //時間條
  onTimeSelected()

  const pickerDate = DateFormat.format.date(date, 'yyyy/MM/dd')
  rentSetting.value = getRentSettingByDate(props.spaceRent, pickerDate)

  if (!rentSetting.value) {
    return
  }

  try {
    /// 初始開始結束範圍
    let timeFlag = rentSetting.value[0].start
    let endTimeStr = rentSetting.value[rentSetting.value.length - 1].end

    /// 23:59 轉 24:00
    if (endTimeStr.endsWith('59')) {
      // endTimeStr = endTimeStr.slice(0, 2) + ':30'
      endTimeStr = "00:00"
    }
    const pushTime = () => {
      // 檢查當前時間是否落在任何設定範圍內
      const isInSettingRange = rentSetting.value.some(setting => {
        return timeFlag >= setting.start && timeFlag <= setting.end
      })

      if (isInSettingRange) {
        startTimeArr.value.push(timeFlag)
      }
      timeBlockArr.value.push({
        time: timeFlag,
        label: timeFlag.endsWith("00") ? timeFlag.slice(0, 2) : '',
        isDisable: !isInSettingRange,
        isActive: false
      })
    }

    pushTime()
    while (timeFlag !== endTimeStr) {
      if (timeFlag.endsWith('00')) {
        timeFlag = timeFlag.slice(0, 2) + ':30'
      } else {
        timeFlag = (parseInt(timeFlag.slice(0, 2)) + 1).toString().padStart(2, '0') + ':00'
      }
      pushTime()
    }

    /// 今天扣掉之前時間
    if (startDate.value === DateFormat.format.date(new Date(), 'yyyy/MM/dd')) {
      const now = DateFormat.format.date(new Date(), 'HH:mm')
      startTimeArr.value = startTimeArr.value.filter(t => t > now)
      timeBlockArr.value.filter(t => t.time < now).forEach(t => t.isDisable = true)
    }

    // todo pc版的sid是用query，mobile版的sid是用params，這邊要改
    /* if(!route.query.sid){
       route.query.sid=route.params.sid
     }*/

    /// 去除已下訂時間
    const res = await getSpaceUsageStatus(parseInt(props.spaceId), pickerDate)
    // 先把非30分或是整點的時間調整到最接近的30分或整點
    res.space_usage_status.forEach((usage) => {
      usage.begin_time = adjustTimeToNearest30(usage.begin_time);
      usage.end_time = adjustTimeToNearest30(usage.end_time);
    });

    res.space_usage_status.forEach((usage) => {
      timeFlag = usage.begin_time.slice(0, 5)
      endTimeStr = usage.end_time.slice(0, 5)
      if (endTimeStr.endsWith('59')) {
        endTimeStr = endTimeStr.slice(0, 2) + ':30'
      }

      /// 起始時間不移除，可選 (重疊)
      const startTimeFlag = timeFlag;
      const endTimeFlag = endTimeStr;

      const spliceTime = () => {
        if (startTimeArr.value.indexOf(timeFlag) !== -1) {
          if (timeFlag !== startTimeFlag && timeFlag !== endTimeFlag) {
            startTimeArr.value.splice(startTimeArr.value.indexOf(timeFlag), 1)
          }
          timeBlockArr.value.filter(t => t.time === timeFlag).forEach(t => t.isDisable = true)
        }
      }

      spliceTime()
      /// 以防 while 卡死，理論上最多跑 48 次，0000~2330
      let count = 0
      while (timeFlag !== endTimeStr && count < 100) {
        if (timeFlag.endsWith('00')) {
          timeFlag = timeFlag.slice(0, 2) + ':30'
        } else {
          timeFlag = (parseInt(timeFlag.slice(0, 2)) + 1).toString().padStart(2, '0') + ':00'
        }
        spliceTime()
        count++
        if (count > 50) {
          console.log('space_usage_status while 資料卡死！！！')
        }
      }
    })

    /// 0800~2200 以上，只顯示偶數時間
    if (timeBlockArr.value.length > 29) {
      timeBlockArr.value
          .filter(t => parseInt(t.label) % 2 === 1)
          .forEach(t => t.label = '')
    }

    /// 預設選第一個
    if (isMounted) {
      startDate.value = DateFormat.format.date(date, 'yyyy/MM/dd')
      startDateShow.value = DateFormat.format.date(date, 'yyyy年MM月dd日 (E)')

      let isOK = false
      if (startTimeArr.value.length > 0) {
        startTime.value = startTimeArr.value[0]
        startTimeSelected()
      }
      if (endTimeArr.value.length > 0) {
        endTime.value = endTimeArr.value[0]
        endTimeSelected()
        isOK = true
      }
      /// lockDate space Usage Status 有被預訂的時間
      if (new DateTime(date, 'YYYY/MM/DD').inArray(lockDate.value, '[]')) {
        isOK = false
      }
      if (isOK) {
        picker.value.setDate(date)
      } else {
        /// 今天已經無法預訂，判斷下一天
        /// 最多跑 30 天
        if (count < 29) {
          date.setDate(date.getDate() + 1)
          await handleSpaceInfo(date, true, count + 1)
        } else {
          picker.value.setDate(date)
        }
      }
    }
  } catch (error) {
    console.log(error)
  }
}

function startTimeSelected() {
  endTime.value = ''
  endTimeArr.value = []

  /// 根據選的起始時間，拉出時間範圍的，最少要幾小時
  let skipTimes = rentSetting.value.find(setting => {
    return startTime.value >= setting.start && startTime.value < setting.end
  })?.shortest_rental_duration ?? 0

  let timeFlag = startTime.value
  startTimeArr.value
      .filter(time => startTime.value < time)
      .forEach(time => {
        if (timeFlag.endsWith('00')) {
          timeFlag = timeFlag.slice(0, 2) + ':30'
        } else {
          timeFlag = (parseInt(timeFlag.slice(0, 2)) + 1).toString().padStart(2, '0') + ':00'
        }
        /// 最低起租小時
        if (timeFlag === time) {
          if (skipTimes > 0.5) {
            skipTimes -= 0.5
          } else {
            endTimeArr.value.push(time)
          }
        }
      })
  onTimeSelected()
}

function endTimeSelected() {
  onTimeSelected()
}

</script>
<style scoped
       lang="scss">
.wrap {
  @apply pt-[16px] relative;

  .date-time-wrap {
    @apply flex flex-col;
  }

  .admin-date-time-wrap {
    @apply flex flex-row justify-center;
  }

  .date-picker-wrap {
    @apply flex items-center justify-center w-full h-[50px] text-[18px] text-osn-dark-grey-00 font-bold rounded-[50px];
    border: 1px solid var(--osn-grey-03, #E1E0E0);

    img {
      @apply w-[20px] mr-[6px];
    }
  }

  .admin-date-picker-wrap {
    @apply w-[335px] mr-[12px];
  }

  .time-picker-wrap {
    @apply flex items-center justify-between mt-[12px] mb-[16px];
    img {
      @apply w-[20px];
    }

    .time-picker {
      @apply relative flex items-center justify-center w-[150px] h-[50px] text-[18px] text-osn-dark-grey-00 font-bold rounded-[50px];
      border: 1px solid var(--osn-grey-03, #E1E0E0);

      img {
        @apply w-[20px] mr-[6px] absolute left-[26px] z-[0];
      }

      select {
        @apply text-center w-full h-full pl-[24px] z-[1] mobile:pl-[48px];
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        border: none;
        background: none;
        outline: none;
      }
    }
  }

  .admin-time-picker-wrap {
    @apply w-fit mt-0;
    img {
      @apply mx-[7px]
    }
  }

  .time-block-wrap {
    @apply flex items-start justify-between w-full mb-[20px];
    .time-block {
      @apply w-full h-full flex flex-col;
      min-width: 0;

      .block {
        @apply h-[18px];
        border-bottom: 1px solid #E1E0E0;
        border-top: 1px solid #E1E0E0;
      }

      .time-block-disable {
        @apply bg-[#E1E0E0];
      }

      .time-block-active {
        @apply bg-[#F7C767];
      }

      .time-block-text {
        @apply h-fit text-[14px] text-osn-grey-01 text-center mt-[8px];
        background-color: transparent !important;
        border: transparent !important;
      }
    }

    .time-block:first-child {
      .block {
        @apply rounded-l-[20px];
        border-left: 1px solid #E1E0E0;
      }
    }

    .time-block:last-child {
      .block {
        @apply rounded-r-[20px];
        border-right: 1px solid #E1E0E0;
      }
    }
  }

  .admin-time-block-wrap {
    @apply w-[336px] mx-auto;
  }

}
</style>
